import { Component, OnInit, Input } from '@angular/core';
import { IAvatarTable } from "../../models/IAvatarTable";

const ELEMENT_DATA: IAvatarTable[] = [
  {
    srcImage: '/assets/images/PeopleThumbnail/1.PNG',
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    columnFive: 'Table row'
  },
  {
    srcImage: '/assets/images/PeopleThumbnail/2.png',
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    columnFive: 'Table row'
  },
  {
    srcImage: '/assets/images/PeopleThumbnail/3.png',
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    columnFive: 'Table row'
  },
  {
    srcImage: '/assets/images/PeopleThumbnail/4.png',
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    columnFive: 'Table row'
  }
];

@Component({
  selector: 'ff-avatar-table',
  templateUrl: './avatar-table.component.html',
  styleUrls: ['./avatar-table.component.scss']
})
export class AvatarTableComponent implements OnInit {

  displayedColumns: string[] = ['columnOne', 'columnTwo', 'columnThree', 'columnFour', 'columnFive'];
  dataSource = ELEMENT_DATA;

  ngOnInit(): void {
  
  }
}
